module.exports = __webpack_public_path__ + "img/largeScreenDesign.e7849e26.svg";